import axios from 'axios';
import { api } from './Api';

// The server signs an idle session out on its own. When that happens every
// subsequent request comes back 401 with code SESSION_EXPIRED, so the browser
// has to notice once and send the person to the sign-in screen — otherwise the
// page just fills up with failed requests and looks broken.

const SIGNIN_PATH = '/signin';
let redirecting = false;

export function clearLocalSession() {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('shippingAddress');
  localStorage.removeItem('paymentMethod');
}

// Tell the server the token is finished so it cannot be replayed, then drop it
// locally. Local cleanup happens either way — a failed call to the server must
// never leave someone stuck signed in.
export async function signOutEverywhere() {
  try {
    const stored = JSON.parse(localStorage.getItem('userInfo') || 'null');
    if (stored?.token) {
      await axios.post(api + '/api/users/signout', {}, {
        headers: { Authorization: `Bearer ${stored.token}` },
      });
    }
  } catch {
    // ignore — signing out locally is what actually matters here
  }
  clearLocalSession();
}

export function installSessionGuard() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401 && error.response.data?.code === 'SESSION_EXPIRED') {
        // Guarded: several requests usually fail together, and each one would
        // otherwise kick off its own redirect.
        if (!redirecting) {
          redirecting = true;
          clearLocalSession();
          window.location.href = `${SIGNIN_PATH}?expired=1`;
        }
      }
      return Promise.reject(error);
    }
  );
}
